import React from "react";
import "./mainTitleItem.less";

const MainTitleItem = ({ value, title, showTitle }) => {
   if (title === "-" || title === null || title === "") return null;
   return (
      <div className="gx-product-body-mainTitle">
         <p className="p1 avdertisement-item-body__title">
            {showTitle === true && <b>{title}: </b>}
            {value}
         </p>
      </div>
   );
};

export default MainTitleItem;
